module.exports = __webpack_public_path__ + "img/home_3.4228a718.jpg";